/* Rod Armour — Yotpo Reviews loader (Opus 4.7 12-May)
   Extracted from inline <script> in layout/theme.liquid to make it
   edge-cacheable and remove ~7KB from every HTML response.
   Configuration is injected via window.RA_YOTPO before this file loads. */
(function () {
  if (!window.RA_YOTPO || !window.RA_YOTPO.storeKey || !window.RA_YOTPO.loaderUrl) {
    return;
  }

  var config = window.RA_YOTPO;
  var yotpoStoreKey = config.storeKey;
  var yotpoLoaderUrl = config.loaderUrl;
  var pageType = config.pageType || '';
  var yotpoLoaderPromise = null;
  var summaryCache = new Map();

  function getSummaryTargets() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-ra-review-summary]'));
  }

  function hasMainWidget() {
    return !!document.querySelector('.yotpo.yotpo-main-widget, .yotpo-widget-instance');
  }

  function ensureReviewsAnchor() {
    if (pageType !== 'product') return null;
    var existingAnchor = document.getElementById('yotpo-reviews');
    if (existingAnchor) return existingAnchor;
    var mainWidget = document.querySelector('.yotpo.yotpo-main-widget');
    if (!mainWidget || !mainWidget.parentNode) return null;
    var fallbackAnchor = document.createElement('span');
    fallbackAnchor.id = 'yotpo-reviews';
    fallbackAnchor.className = 'ra-yotpo-reviews-anchor ra-yotpo-reviews-anchor--fallback';
    fallbackAnchor.setAttribute('aria-hidden', 'true');
    fallbackAnchor.style.scrollMarginTop = '120px';
    mainWidget.parentNode.insertBefore(fallbackAnchor, mainWidget);
    return fallbackAnchor;
  }

  function renderStars(summary, averageScore) {
    var fill = summary.querySelector('.ra-review-summary__stars-fill');
    if (!fill) return;
    var safeAverage = Number.isFinite(averageScore) ? Math.max(0, Math.min(5, averageScore)) : 0;
    fill.style.width = ((safeAverage / 5) * 100).toFixed(2) + '%';
  }

  function reviewLabel(summary) {
    if (summary) {
      var directLabel = summary.getAttribute('data-review-label');
      if (directLabel) return directLabel;
    }
    var localizedSummary = document.querySelector('[data-ra-review-summary][data-review-label]');
    var localizedLabel = localizedSummary ? localizedSummary.getAttribute('data-review-label') : '';
    return localizedLabel || 'Reviews';
  }

  function renderSummary(summary, payload) {
    if (!summary || !payload) return;
    var count = Number(payload.totalReviews) || 0;
    var averageScore = Number(payload.averageScore) || 0;
    var countLabel = reviewLabel(summary);
    var countNode = summary.querySelector('.ra-review-summary__count');
    var srLabel = summary.querySelector('.ra-review-summary__label');
    var wrapper = summary.closest('.ra-yotpo-stars, .ra-best-match__reviews');
    renderStars(summary, averageScore);
    if (countNode) countNode.textContent = count + ' ' + countLabel;
    if (srLabel) {
      srLabel.textContent = count > 0
        ? averageScore.toFixed(1) + '/5 · ' + count + ' ' + countLabel
        : '0 ' + countLabel;
    }
    summary.dataset.raAverageScore = averageScore.toFixed(4);
    summary.dataset.raTotalReviews = String(count);
    summary.dataset.raReviewLoaded = 'true';
    summary.setAttribute('aria-busy', 'false');
    summary.classList.remove('ra-review-summary--unavailable');
    summary.classList.toggle('ra-review-summary--empty', count === 0);
    if (wrapper) {
      wrapper.classList.remove('ra-yotpo-stars--unavailable', 'ra-best-match__reviews--unavailable');
      wrapper.classList.toggle('ra-yotpo-stars--empty', count === 0);
      wrapper.classList.toggle('ra-best-match__reviews--empty', count === 0);
    }
  }

  function markSummaryUnavailable(summary) {
    if (!summary) return;
    var countNode = summary.querySelector('.ra-review-summary__count');
    var srLabel = summary.querySelector('.ra-review-summary__label');
    var wrapper = summary.closest('.ra-yotpo-stars, .ra-best-match__reviews');
    renderStars(summary, 0);
    if (countNode) countNode.textContent = '';
    if (srLabel) srLabel.textContent = reviewLabel(summary);
    summary.dataset.raReviewLoaded = 'true';
    summary.setAttribute('aria-busy', 'false');
    summary.classList.add('ra-review-summary--unavailable');
    summary.classList.remove('ra-review-summary--empty');
    if (wrapper) {
      wrapper.classList.add('ra-yotpo-stars--unavailable', 'ra-best-match__reviews--unavailable');
      wrapper.classList.remove('ra-yotpo-stars--empty', 'ra-best-match__reviews--empty');
    }
  }

  function fetchSummary(productId) {
    if (!productId) return Promise.resolve(null);
    if (summaryCache.has(productId)) return summaryCache.get(productId);
    var request = fetch('https://api-cdn.yotpo.com/v3/storefront/store/' + yotpoStoreKey + '/product/' + productId + '/ratings')
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to fetch rating summary.');
        return response.json();
      })
      .then(function (payload) {
        return payload && payload.bottomline ? payload.bottomline : null;
      })
      .catch(function () { return null; });
    summaryCache.set(productId, request);
    return request;
  }

  function hydrateSummary(summary) {
    if (!summary || summary.dataset.raReviewLoaded === 'true' || summary.dataset.raReviewLoading === 'true') return;
    summary.dataset.raReviewLoading = 'true';
    fetchSummary(summary.dataset.productId).then(function (payload) {
      if (payload) renderSummary(summary, payload);
      else markSummaryUnavailable(summary);
    }).finally(function () {
      delete summary.dataset.raReviewLoading;
    });
  }

  function hydrateAllVisibleSummaries() {
    getSummaryTargets().forEach(hydrateSummary);
  }

  function loadYotpo() {
    if (!hasMainWidget()) return Promise.resolve(null);
    if (window.yotpoWidgetsContainer && document.querySelector('script[data-ra-yotpo-loader]')) {
      return Promise.resolve(window.yotpoWidgetsContainer);
    }
    if (yotpoLoaderPromise) return yotpoLoaderPromise;
    yotpoLoaderPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-ra-yotpo-loader]');
      if (existing) {
        resolve(window.yotpoWidgetsContainer || window.Yotpo || window.yotpo || true);
        return;
      }
      var script = document.createElement('script');
      script.src = yotpoLoaderUrl;
      script.async = true;
      script.defer = true;
      script.setAttribute('data-ra-yotpo-loader', 'true');
      script.addEventListener('load', function () {
        resolve(window.yotpoWidgetsContainer || window.Yotpo || window.yotpo || true);
      });
      script.addEventListener('error', function () {
        yotpoLoaderPromise = null;
        reject(new Error('Failed to load Yotpo.'));
      });
      document.head.appendChild(script);
    });
    return yotpoLoaderPromise;
  }

  function observeSummaryTargets() {
    var summaries = getSummaryTargets();
    if (!summaries.length) return;
    if ('IntersectionObserver' in window) {
      var summaryObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          hydrateSummary(entry.target);
          summaryObserver.unobserve(entry.target);
        });
      }, { rootMargin: pageType === 'product' ? '360px 0px' : '240px 0px' });

      summaries.forEach(function (summary) {
        var isPrimaryProductSummary = pageType === 'product' && !!summary.closest('.ra-mobile-reviews, .product-block--header');

        if (isPrimaryProductSummary) {
          hydrateSummary(summary);
          return;
        }

        summaryObserver.observe(summary);
      });
      return;
    }
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(hydrateAllVisibleSummaries, { timeout: 1200 });
    } else {
      window.setTimeout(hydrateAllVisibleSummaries, 600);
    }
  }

  function observeMainWidget() {
    var mainWidget = document.querySelector('.yotpo.yotpo-main-widget');
    if (!mainWidget) return;
    ensureReviewsAnchor();
    if ('IntersectionObserver' in window) {
      var widgetObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          widgetObserver.disconnect();
          loadYotpo();
        });
      }, { rootMargin: '1200px 0px' });
      widgetObserver.observe(mainWidget);
      return;
    }
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadYotpo, { timeout: 2500 });
    } else {
      window.setTimeout(loadYotpo, 1800);
    }
  }

  function wireTopicsToggle(container) {
    if (!container || container.dataset.raTopicsWired === 'true') return;
    if (container.nextElementSibling && container.nextElementSibling.classList.contains('ra-yotpo-topics-toggle')) {
      container.dataset.raTopicsWired = 'true';
      return;
    }
    container.dataset.raTopicsWired = 'true';
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'ra-yotpo-topics-toggle';
    toggle.textContent = 'Show more';
    toggle.setAttribute('aria-expanded', 'false');
    container.insertAdjacentElement('afterend', toggle);
    toggle.addEventListener('click', function () {
      var expanded = container.classList.toggle('is-expanded');
      toggle.textContent = expanded ? 'Show less' : 'Show more';
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function normaliseYotpoCopy(root) {
    var reviews = root.querySelectorAll('.yotpo-review');
    for (var i = 0; i < reviews.length; i++) {
      var review = reviews[i];
      var name = review.querySelector('.yotpo-reviewer-name-text, .yotpo-reviewer-name, .yotpo-user-name');
      var avatar = review.querySelector('.yotpo-reviewer-image, .yotpo-icon-profile, .yotpo-user-thumbnail');
      if (name) {
        var cleanName = name.textContent.replace(/(?:\uD83C[\uDDE6-\uDDFF]){2}/g, '').replace(/\s{2,}/g, ' ').trim();
        if (cleanName && cleanName !== name.textContent.trim()) {
          name.textContent = cleanName;
        }
      }
      if (avatar && name && avatar.dataset.raInitialName !== name.textContent.trim()) {
        avatar.dataset.raInitial = name.textContent.trim().charAt(0).toUpperCase() || 'R';
        avatar.dataset.raInitialName = name.textContent.trim();
      }
      var verified = review.querySelector('.yotpo-reviewer-verified-buyer-text, .yotpo-verified-buyer-label');
      if (verified && verified.textContent.trim() !== 'Verified buyer') {
        verified.textContent = 'Verified buyer';
        verified.dataset.raVerifiedText = 'true';
      }
    }

    var buttons = root.querySelectorAll('.yotpo-new-review-btn, .write-review-button, [class*="write-review-btn"]');
    for (var j = 0; j < buttons.length; j++) {
      var buttonText = buttons[j].textContent.trim();
      if (/write\s+a\s+review/i.test(buttonText) && buttonText !== 'Write a review') {
        buttons[j].textContent = 'Write a review';
      }
      if (buttons[j].getAttribute('aria-label') !== 'Write a review') {
        buttons[j].setAttribute('aria-label', 'Write a review');
      }
    }

    var selectedValues = root.querySelectorAll('.yotpo-sorting-filter-container .yotpo-selected-value');
    for (var k = 0; k < selectedValues.length; k++) {
      var value = selectedValues[k];
      var cleaned = value.textContent.replace(/^Sort\s+by\s*:?\s*/i, '').trim();
      if (cleaned && cleaned !== value.textContent.trim()) {
        value.textContent = cleaned;
      }
    }

    syncYotpoSortLabels(root);
  }

  function syncYotpoSortLabels(root) {
    var scope = root || document;
    var containers = scope.querySelectorAll('.yotpo-sorting-filter-container');

    for (var i = 0; i < containers.length; i++) {
      var selectedValue = containers[i].querySelector('.yotpo-selected-value');
      var selectedOption = containers[i].querySelector('[role="option"][aria-selected="true"], .yotpo-dropdown-option--selected');
      if (!selectedValue || !selectedOption) continue;

      var optionLabel = selectedOption.querySelector('.yotpo-dropdown-option-label') || selectedOption;
      var nextLabel = optionLabel.textContent.replace(/^Sort\s+by\s*:?\s*/i, '').trim();
      if (nextLabel && selectedValue.textContent.trim() !== nextLabel) {
        selectedValue.textContent = nextLabel;
      }
    }
  }

  function scheduleSortLabelSync(root) {
    window.setTimeout(function () { syncYotpoSortLabels(root || document); }, 80);
    window.setTimeout(function () { syncYotpoSortLabels(root || document); }, 350);
  }

  function normaliseYotpoWidget() {
    var roots = document.querySelectorAll('.yotpo-widget-instance, .yotpo.yotpo-main-widget');
    for (var i = 0; i < roots.length; i++) {
      normaliseYotpoCopy(roots[i]);
      normaliseAggregateScore(roots[i]);
    }
  }

  function normaliseAggregateScore(root) {
    var rows = root.querySelectorAll('.yotpo-star-distribution-row-wrapper, .yotpo-distribution-row');
    var total = 0;
    var weighted = 0;

    for (var i = 0; i < rows.length; i++) {
      var scoreEl = rows[i].querySelector('.yotpo-star-distribution-index, .yotpo-star-distribution-index-wrapper');
      var countEl = rows[i].querySelector('.yotpo-star-distribution-value');
      if (!scoreEl || !countEl) continue;

      var score = parseInt(scoreEl.textContent.replace(/[^\d]/g, ''), 10);
      var count = parseInt(countEl.textContent.replace(/[^\d]/g, ''), 10);
      if (!score || Number.isNaN(score) || Number.isNaN(count)) continue;

      total += count;
      weighted += score * count;
    }

    if (!total || !weighted) return;

    var average = weighted / total;
    var formatted = average === 5 ? '5.0' : (Math.floor(average * 10) / 10).toFixed(1);
    var scoreNode = root.querySelector('.yotpo-bottom-line-score, .yotpo-bottomline-score');
    if (scoreNode && scoreNode.textContent.trim() !== formatted) {
      scoreNode.textContent = formatted;
      scoreNode.setAttribute('aria-label', formatted + ' out of 5 stars');
    }

    var basedNode = root.querySelector('.yotpo-bottom-line-text, .yotpo-bottomline-text, .yotpo-bottom-line-basic-text');
    if (basedNode && total > 0 && !new RegExp(String(total)).test(basedNode.textContent)) {
      basedNode.textContent = total.toLocaleString() + ' ' + reviewLabel();
    }
  }

  function findAndWireTopics() {
    markReviewImagesLazy();
    normaliseYotpoWidget();
    applyHybridDates();
    var selectors = [
      '.yotpo-popular-topics',
      '.yotpo-keywords-container',
      '.yotpo-topic-chips',
      '.yotpo-headerizer-tags'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var nodes = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < nodes.length; j++) {
        if (nodes[j].children && nodes[j].children.length > 3) {
          wireTopicsToggle(nodes[j]);
        }
      }
    }
    var duplicateToggles = document.querySelectorAll('.ra-yotpo-topics-toggle + .ra-yotpo-topics-toggle');
    for (var k = 0; k < duplicateToggles.length; k++) {
      duplicateToggles[k].remove();
    }
  }

  function markReviewImagesLazy() {
    var images = document.querySelectorAll('.yotpo-main-widget img, .yotpo-reviews-main-widget img, .yotpo-widget-instance img');
    for (var i = 0; i < images.length; i++) {
      if (!images[i].hasAttribute('loading')) {
        images[i].setAttribute('loading', 'lazy');
      }
      if (!images[i].hasAttribute('decoding')) {
        images[i].setAttribute('decoding', 'async');
      }
    }
  }

  function observeForTopics() {
    findAndWireTopics();
    if (!('MutationObserver' in window)) return;
    var widget = document.querySelector('.yotpo-widget-instance, .yotpo.yotpo-main-widget');
    if (!widget) return;
    var topicsTimer = null;
    var topicsObserver = new MutationObserver(function () {
      if (topicsTimer) return;
      topicsTimer = window.setTimeout(function () {
        topicsTimer = null;
        findAndWireTopics();
      }, 120);
    });
    topicsObserver.observe(widget, { childList: true, subtree: true });

    widget.addEventListener('click', function (event) {
      if (!event.target.closest('.yotpo-sorting-filter-container')) return;
      scheduleSortLabelSync(widget);
    }, true);
  }

  function parseYotpoDate(raw) {
    if (!raw) return null;
    raw = String(raw).replace(/^Published date\s*/i, '').trim();
    var usDate = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/);
    if (usDate) {
      var year = Number(usDate[3]);
      if (year < 100) year += 2000;
      return new Date(year, Number(usDate[1]) - 1, Number(usDate[2]));
    }
    var date = new Date(raw);
    return isNaN(date.getTime()) ? null : date;
  }

  function formatHybridDate(dateEl) {
    if (!dateEl) return;
    var raw = dateEl.getAttribute('datetime') || dateEl.textContent.trim();
    if (raw === dateEl.dataset.raHybridRaw) return;
    var date = parseYotpoDate(raw);
    if (!date) return;

    var now = new Date();
    var diffMs = now - date;
    var diffDays = Math.floor(diffMs / 86400000);
    var formatted;

    if (diffDays < 1) {
      var hours = Math.floor(diffMs / 3600000);
      formatted = hours <= 1 ? 'just now' : hours + ' hours ago';
    } else if (diffDays < 7) {
      formatted = diffDays === 1 ? '1 day ago' : diffDays + ' days ago';
    } else if (diffDays < 30) {
      var weeks = Math.floor(diffDays / 7);
      formatted = weeks === 1 ? '1 week ago' : weeks + ' weeks ago';
    } else {
      var months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
      formatted = date.getDate() + ' ' + months[date.getMonth()] + ' ' + date.getFullYear();
    }

    dateEl.textContent = formatted;
    dateEl.dataset.raHybridRaw = raw;
  }

  function applyHybridDates() {
    var selector = '.yotpo-widget-instance .yotpo-review-date, .yotpo-widget-instance .y-label.yotpo-review-date';
    Array.prototype.slice.call(document.querySelectorAll(selector)).forEach(formatHybridDate);
  }

  function observeHybridDates() {
    applyHybridDates();
    window.setTimeout(applyHybridDates, 2000);
    window.setTimeout(applyHybridDates, 5000);
    if (!('MutationObserver' in window)) return;
    var widget = document.querySelector('.yotpo-widget-instance, .yotpo.yotpo-main-widget');
    if (!widget) return;
    var dateTimer = null;
    var dateObserver = new MutationObserver(function () {
      if (dateTimer) return;
      dateTimer = window.setTimeout(function () {
        dateTimer = null;
        applyHybridDates();
      }, 120);
    });
    dateObserver.observe(widget, { childList: true, subtree: true });
    window.setTimeout(function () { dateObserver.disconnect(); }, 12000);
  }

  function init() {
    ensureReviewsAnchor();
    observeSummaryTargets();
    observeMainWidget();
    observeForTopics();
    observeHybridDates();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
